"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconReceiptCheck = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconReceiptCheck = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7587 2H15.2413C16.0463 1.99999 16.7106 1.99998 17.2518 2.0442C17.8139 2.09012 18.3306 2.18868 18.816 2.43598C19.5686 2.81947 20.1805 3.43139 20.564 4.18404C20.8113 4.66938 20.9099 5.18608 20.9558 5.74818C21 6.28937 21 6.95372 21 7.75868V21C21 21.3761 20.7889 21.7204 20.4538 21.8911C20.1186 22.0618 19.716 22.03 19.4118 21.8087L17.2789 20.2575L15.3747 21.7809C15.0229 22.0623 14.5262 22.0738 14.1618 21.8087L12 20.2365L9.83817 21.8087C9.47378 22.0738 8.97715 22.0623 8.62531 21.7809L6.72111 20.2575L4.58817 21.8087C4.28399 22.03 3.88139 22.0618 3.54622 21.8911C3.21105 21.7204 3 21.3761 3 21V7.75869C2.99999 6.95373 2.99998 6.28936 3.0442 5.74818C3.09012 5.18608 3.18868 4.66938 3.43598 4.18404C3.81947 3.43139 4.43139 2.81947 5.18404 2.43598C5.66938 2.18868 6.18608 2.09012 6.74818 2.0442C7.28936 1.99998 7.95375 1.99999 8.7587 2ZM16.2071 8.70711C16.5976 8.31658 16.5976 7.68342 16.2071 7.29289C15.8166 6.90237 15.1834 6.90237 14.7929 7.29289L11 11.0858L9.70711 9.79289C9.31658 9.40237 8.68342 9.40237 8.29289 9.79289C7.90237 10.1834 7.90237 10.8166 8.29289 11.2071L10.2929 13.2071C10.6834 13.5976 11.3166 13.5976 11.7071 13.2071L16.2071 8.70711Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 10.5L11 12.5L15.5 8M20 21V7.8C20 6.11984 20 5.27976 19.673 4.63803C19.3854 4.07354 18.9265 3.6146 18.362 3.32698C17.7202 3 16.8802 3 15.2 3H8.8C7.11984 3 6.27976 3 5.63803 3.32698C5.07354 3.6146 4.6146 4.07354 4.32698 4.63803C4 5.27976 4 6.11984 4 7.8V21L6.75 19L9.25 21L12 19L14.75 21L17.25 19L20 21Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconReceiptCheck = IconReceiptCheck;
//# sourceMappingURL=IconReceiptCheck.js.map